import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Link from 'next/link';
import React, { useState } from 'react';
import Image from 'next/image';
import pc from './PopularCategories.module.scss';

const settings = {
    //   dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    //   centerMode: true,
    //   centerPadding: '0px',
};

import freza1 from '/public/static/images/frz1.webp';
import freza4 from '/public/static/images/frz4.webp';
import freza3 from '/public/static/images/frz3.webp';
import freza2 from '/public/static/images/frz2.webp';
import freza5 from '/public/static/images/frz5.webp';
import freza6 from '/public/static/images/frz6.webp';
import { Flex, Layout, Typography } from 'antd';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';
const PopularCategories = () => {
    const LOCALIZATION = useLocalization();
    const popularCategories = [
        {
            name: LOCALIZATION.pages.index.sixthCard.temp.first,
            url: 'catalog/machine-tool',
            image: freza1,
            count: 11,
        },
        {
            name: LOCALIZATION.pages.index.sixthCard.temp.second,
            url: 'catalog/hand-tool',
            image: freza4,
            count: 3,
        },
        {
            name: LOCALIZATION.pages.index.sixthCard.temp.third,
            url: 'catalog/hand-measuring-tool',
            image: freza3,
            count: 2,
        },
        {
            name: LOCALIZATION.pages.index.sixthCard.temp.fourth,
            url: '',
            image: freza2,
            count: 0,
            disabled: true,
        },
        {
            name: LOCALIZATION.pages.index.sixthCard.temp.five,
            url: '',
            image: freza5,
            count: 0,
            disabled: true,
        },
        {
            name: LOCALIZATION.pages.index.sixthCard.temp.sixth,
            url: '',
            image: freza6,
            count: 0,
            disabled: true,
        },
    ];

    return (
        <Flex
            gap={'20px'}
            vertical
            className={pc.container}
        >
            <Typography.Text className="text-32-500">
                {LOCALIZATION.pages.index.sixthCard.title}
            </Typography.Text>
            {/*<Slider {...settings}>*/}
            {/*    */}
            {/*</Slider>*/}
            <Layout className={pc.container_body}>
                {popularCategories.map((el, i) => {
                    return (
                        <Link
                            href={el.url}
                            className={pc.item}
                            key={i}
                        >
                            <div className={pc.item__image}>
                                <Image
                                    style={{ width: '100%', height: '100%' }}
                                    src={el.image}
                                    className={pc.item__image__Image}
                                    width={0}
                                    height={0}
                                    sizes={'100%'}
                                    alt=""
                                />
                            </div>
                            <div className={pc.item__data}>
                                <span className={`text-[#0B0B0C] ${pc.data__title}`}>
                                    {el.name}
                                </span>
                                <span className={`text-[#5A5B5D] ${pc.data__count}`}>
                                    {el.count} {LOCALIZATION.pages.index.sixthCard.countTitle}
                                </span>
                            </div>
                        </Link>
                    );
                })}
            </Layout>
        </Flex>
    );
};

export default PopularCategories;
